"use client";

import React, { useState } from 'react';
import { Block } from '../../interfaces.ts';
import TemplateSettingsDialog from './TemplateSettingsDialog.tsx';

interface ContainerBlockTemplateSettingsDialogProps {
  block: Block;
  onClose: () => void;
  onSave: (updatedBlock: Block) => void;
}

const ContainerBlockTemplateSettingsDialog: React.FC<ContainerBlockTemplateSettingsDialogProps> = ({
  block,
  onClose,
  onSave,
}) => {
  const initialColumns = block.properties?.layout?.length || 1;

  const [columns, setColumns] = useState<number>(initialColumns);

  const handleSave = () => {
    onSave({
      ...block,
      properties: {
        ...block.properties,
        layout: Array(columns).map(() => 100/columns),
      },
    });
  };

  return (
    <TemplateSettingsDialog
      title="Container Block Settings"
      onClose={onClose}
      onSave={handleSave}
    >
      <div className="mb-4">
        <label className="block mb-2">
          Number of Columns:
          <input
            type="number"
            min="1"
            max="3"
            className="w-full border border-solid border-gray-300 rounded mt-1 p-1"
            value={columns}
            onChange={(e) => setColumns(parseInt(e.target.value) || 1)}
          />
        </label>
      </div>
    </TemplateSettingsDialog>
  );
};

export default ContainerBlockTemplateSettingsDialog;